module.exports = __webpack_public_path__ + "static/media/website-logo2.a5a2224c.png";